import React from 'react';
import { InfoTooltip, useStyles } from '@webapps/styles';
import { Share } from '@material-ui/icons';
import { Button } from '@material-ui/core';
import CFASchool from 'components/Icons/CFASchool';
import { useHistory } from 'react-router-dom';
import { ROUTES_PATH } from 'config/constants';
import { formatDate224, pluralize } from '@webapps/utils';

export default function School({ stat }) {
  const { classes, global, cx } = useStyles(styles);
  const { push } = useHistory();

  return (
    <div className={classes.card}>
      <CFASchool className={classes.image} />
      <div className={classes.content}>
        <div className={classes.header}>
          <div className={cx(global.title, global.ellipsis)}>{`${stat?.count || 0} ${pluralize("Organisme", stat?.count)} de formation`}</div>
          <InfoTooltip
            position="bottom"
            forceVisible={false}
            title="Comment ça marche ?"
            description="Gérez vos organismes de formation partenaires. Vous pouvez en inviter de nouveaux pour simplifier la gestion des dossiers."
            link={{ text: "En savoir plus" }}
          />
        </div>
        <div className={classes.date}>{`Dernière modification ${formatDate224(stat?.lastUpdate)}`}</div>
        <Button className={global.buttonCFADashboard} onClick={() => push(ROUTES_PATH.CFA_ORGANISMES, { generateCode: true })} >
          <div className={global.buttonCFADashboardText}>Inviter un OF</div>
        </Button>
      </div>
    </div>
  );
}

const styles = ({ spacing }) => ({
  card: {
    alignItems: 'center',
    backgroundColor: '#ffffff',
    borderRadius: '10px',
    display: 'flex',
    flexDirection: 'row',
    flexGrow: 1,
    padding: '20px',
    gap: '20px',
    overflow: 'visible',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    overflow: 'visible',
  },
  image: {
    width: '71px',
  },
  header: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    gap: '6px',
    overflow: 'visible',
  },
  title: {
    fontFamily: '"Montserrat", sans-serif',
    fontSize: '15px',
    fontWeight: 600,
    lineHeight: '14px',
    color: '#152652',
  },
  infoIcon: {
    height: '16px',
    width: '16px',
    fill: '#a8caff',
  },
  date: {
    fontFamily: '"Roboto", sans-serif',
    fontSize: '12px',
    lineHeight: '12px',
    color: '#5d75a8',
  },
});